import type { ComponentProps, FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

const Textarea: FC<ComponentProps<'textarea'>> = ({ className, ...props }): ReactNode => {
    return (
        <textarea
            data-slot='textarea'
            className={cn(
                'block min-h-32 w-full rounded-lg border border-input bg-card px-3.5 py-3 text-base leading-relaxed text-foreground transition-colors placeholder:text-muted-foreground/75 hover:border-foreground/60 disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-destructive',
                className
            )}
            {...props}
        />
    )
}

export { Textarea }
